import React, { useEffect, useState } from 'react';
import {
    Dialog,
    Box,
    Typography,
    Button,
    IconButton,
    Grid,
    Stack,
    Divider
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Formik } from 'formik';

import get from "lodash/get";
import DatePickerUi from "../../../components/form/DatePickerUi";
import CloseIcon from '@mui/icons-material/Close';
import SaveIcon from '@mui/icons-material/Save';
import {getRouteDowloand} from "../../../store/transactions/thunk/route/getAllDowloand";
import { useDispatch, useSelector } from "react-redux";

import Validator from "./validatorDowloandRoutes";

const Alert = ({
    __,
    open,
    close
}) => {
    const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
    const dispatch = useDispatch();
    const routesDowloand = useSelector((state) => state.transactions.route.routesDowloand);
    
    const onCloseModal = (r) => {
        close();
    };

    const closeAlert = () => {
        setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
    }

    const formatDate = (date) => {
        return date.toISOString().split("T")[0].replace(/-/g, "/");
    };

    const onSubmit = (values) => {
        let RangoFecha = {
            startDate: formatDate(new Date(get(values, "startDate"))),
            endDate: formatDate(new Date(get(values, "endDate")))
        }
        dispatch(getRouteDowloand(RangoFecha));
        close();
    };

    const initialValues = {

        startDate: "",
        endDate: ""
    }

    return (
        <div>
            <Dialog onClose={close} open={open} maxWidth="lg" fullWidth>
                <Box>
                    <Typography variant="h6" sx={{ mt: 2, mb: 1, ml: 3 }}>
                        {__("labels.21")}
                    </Typography>
                    <IconButton
                        aria-label="close"
                        onClick={close}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
                <div>
                {!open
                        ? (
                            <Box sx={{ minHeight: 200, width: "100%" }} />
                        ) : (
                            <Formik initialValues={initialValues}
                               validationSchema={Validator(__)}
                                onSubmit={onSubmit}>
                                {formik => (
                                    <form id="route-dowloand-form" onSubmit={get(formik, "handleSubmit")}>
                                        <div className='relative'>
                                            <Divider />
                                            <Box className='p-4' >
                                                <Grid container spacing={{ xs: 2, md: 3 }}>
                                                    <Grid item xs={12} sm={6}>
                                                        <DatePickerUi
                                                            formik={formik}
                                                            name="startDate"
                                                            label={__(`form.startDate.label`)}
                                                            placeholder={__(`form.startDate.placeholder`)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <DatePickerUi
                                                            formik={formik}
                                                            name="endDate"
                                                            label={__(`form.endDate.label`)}
                                                            placeholder={__(`form.endDate.placeholder`)}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        )}
                </div>
                <Stack className='p-4' direction="row" spacing={2} justifyContent="flex-end">
                    <LoadingButton variant="contained" startIcon={<SaveIcon/>} color="secondary" type="submit" form="route-dowloand-form">{__("action.dowloand")}</LoadingButton>
                    <Button variant='outlined' color="secondary" onClick={onCloseModal} >{__(`action.cancel`)}</Button>
                </Stack>
            </Dialog>
        </div >
    );
}

export default Alert